import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener("show-session-modal", this.showWithEmail.bind(this))
  }

  disconnect() {
    document.removeEventListener("show-session-modal", this.showWithEmail.bind(this))
  }

  showWithEmail(event) {
    $("#session-modal").modal("show")
    const email = event.detail.email
    if (email) {
      const input = document.getElementById("user_login")
      input.value = email
    }
  }
}
